import { render, staticRenderFns } from "./Mcompleted.vue?vue&type=template&id=2b75afee&"
import script from "./Mcompleted.vue?vue&type=script&lang=js&"
export * from "./Mcompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports